import type { Chapter } from '../types.ts';
import { renderHero } from './hero.ts';

export function renderChapter(chapter: Chapter): HTMLElement {
  const article = document.createElement('article');
  article.className = 'chapter';
  article.id = `${chapter.number}-${chapter.slug}`;
  article.dataset['chapter'] = String(chapter.number);
  article.setAttribute('aria-labelledby', `${article.id}-title`);

  const hero = renderHero(chapter);
  const titleEl = hero.querySelector('.hero-title');
  if (titleEl) titleEl.id = `${article.id}-title`;
  article.appendChild(hero);

  const narration = document.createElement('div');
  narration.className = 'narration';
  narration.innerHTML = chapter.narrationHtml;

  if (chapter.pullQuote) {
    const pullQuote = document.createElement('blockquote');
    pullQuote.className = 'pull-quote';
    pullQuote.textContent = chapter.pullQuote;
    const firstP = narration.querySelector('p');
    if (firstP && firstP.nextSibling) {
      narration.insertBefore(pullQuote, firstP.nextSibling);
    } else {
      narration.appendChild(pullQuote);
    }
  }

  article.appendChild(narration);

  const figure = document.createElement('figure');
  figure.className = 'infographic';
  const img = document.createElement('img');
  img.className = 'infographic-img';
  img.src = chapter.infographic;
  img.alt = `Infographic for chapter ${chapter.number}: ${chapter.title}`;
  img.loading = chapter.number === 1 ? 'eager' : 'lazy';
  img.decoding = 'async';
  figure.appendChild(img);
  article.appendChild(figure);

  return article;
}
